(function () {
  // Preselect a size on product pages, unless the shopper arrived via a
  // specific ?variant= link.
  //
  // WHICH size is inventory-aware. We prefer 6'x9' (best seller), but only
  // while it can actually ship. When 6'x9' is oversold we fall back to the
  // first in-stock size, so organic and direct landings lead with something
  // buyable instead of a pre-order. The moment a restock puts 6'x9' back above
  // zero this flips back on its own - no redeploy.
  //
  // Inventory comes from the data-variants JSON that product-almost-gone.liquid
  // already renders server-side: [{id,title,tracked,qty,policy}, ...].
  //
  // Swatch King renders the VISIBLE pills and is set preselect_variant:false,
  // so we click ITS pill first, then fall back to Dawn's radio, then a <select>.
  // SK is a third-party script that routinely renders buttons before binding
  // their handlers, so the three permitted clicks are spread by ELAPSED TIME
  // (~0s / ~1.5s / ~3.5s) with a grace period to ~5s. Hard cap: 3 SK clicks per
  // page load - each one can trigger a variant section fetch. The 8s deadline
  // in start() backstops everything; the loop is self-cancelling.
  //
  // 2026-09-14 fix: "6'x9' selected but price still shows the 5'x7' price".
  // Dawn only updates price / form id / pre-order UI from a `change` event that
  // <variant-selects> listens for in its connectedCallback. This script is
  // loaded before product-info.js, so the radio click could land before that
  // listener existed: the pill turned on, the event went nowhere, and the page
  // kept the 5'x7' price and variant id. Two guards now cover that:
  //   (a) never click a Dawn radio until <variant-selects> is defined, and
  //   (b) "done" means the theme's own [data-selected-variant] JSON (or the
  //       form's variant id) actually matches the target, not just that the
  //       radio is checked. If it doesn't, re-dispatch `change` (capped).
  if (window.__smPreselectSizeLoaded) return;   // asset is included twice
  window.__smPreselectSizeLoaded = true;

  var PREFERRED = "6'x9'";
  var SK_ATTEMPT_AT = [0, 1500, 3500];
  var SK_GIVE_UP_AT = 5000;
  var WAIT_FOR_DAWN_UNTIL = 5000;   // ms to wait for variant-selects to define
  var MAX_RESYNC = 3;               // extra change events we allow per load
  var skClicks = 0;
  var resyncs = 0;
  var startedAt = Date.now();
  var chosen = null;

  function norm(s) { return (s || '').toString().replace(/\s+/g, '').replace(/[’ʼ′]/g, "'").toLowerCase(); }

  function variantData() {
    var el = document.querySelector('[data-variants]');
    if (!el) return null;
    try {
      var d = JSON.parse(el.getAttribute('data-variants'));
      return (d && d.length) ? d : null;
    } catch (e) { return null; }
  }

  function inStock(v) {
    if (!v) return false;
    if (v.tracked === false) return true;   // untracked never blocks
    return Number(v.qty) > 0;
  }

  function findByTitle(data, size) {
    var n = norm(size);
    var exact = data.filter(function (v) { return norm(v.title) === n; })[0];
    if (exact) return exact;
    // Multi-option products render titles like "Olive / 6'x9'".
    return data.filter(function (v) { return norm(v.title).indexOf(n) !== -1; })[0] || null;
  }

  // Resolve once, and only once real inventory data is on the page. Until then
  // return PREFERRED without caching, so a later tick can still decide properly.
  function resolveTarget() {
    if (chosen) return chosen;
    var data = variantData();
    if (!data) return PREFERRED;
    var pref = findByTitle(data, PREFERRED);
    if (!pref || inStock(pref)) { chosen = PREFERRED; return chosen; }
    var alt = data.filter(inStock)[0];
    chosen = alt ? alt.title : PREFERRED;
    return chosen;
  }

  // Does the THEME think the target is selected? Dawn re-renders a
  // [data-selected-variant] JSON block on every successful variant change,
  // and product-form's hidden input[name="id"] carries the cart variant id.
  function themeHasTarget(scope, target) {
    var n = norm(target);
    var el = scope.querySelector('[data-selected-variant]');
    if (el) {
      try {
        var v = JSON.parse(el.textContent);
        if (v && v.title != null) return norm(v.title).indexOf(n) !== -1;
      } catch (e) { /* fall through */ }
    }
    var data = variantData();
    var idInput = scope.querySelector('input[name="id"]');
    if (data && idInput) {
      var cur = data.filter(function (v) { return String(v.id) === String(idInput.value); })[0];
      if (cur) return norm(cur.title).indexOf(n) !== -1;
    }
    return null;   // can't tell on this theme; trust the radio
  }

  function preselect() {
    if (/[?&]variant=/.test(window.location.search)) return true;
    var TARGET = resolveTarget();
    var scope = document.querySelector('product-info') || document;
    var elapsed = Date.now() - startedAt;

    // 1) Swatch King's visible pills. Match ONLY on exact normalized text: the
    // same template also renders a Style/colour swatch group whose buttons can
    // navigate to a different linked product, so never click by position or by
    // a broad [data-value] sweep.
    var skButtons = document.querySelectorAll('.swatch-single .swatch-button');
    var skMatch = Array.prototype.filter.call(skButtons, function (b) {
      return norm(b.textContent) === norm(TARGET);
    })[0];
    var skSelected = false;
    if (skMatch) {
      // The pill being visibly selected is necessary but NOT sufficient: SK
      // can flip its pill and Dawn's radio while Dawn's change handler was
      // never reached, which leaves the 5'x7' price and variant id on the
      // page. So fall through to the Dawn check below even when selected.
      skSelected = skMatch.classList.contains('swatch-selected');
      if (!skSelected) {
        if (skClicks < SK_ATTEMPT_AT.length) {
          if (elapsed >= SK_ATTEMPT_AT[skClicks]) { skClicks++; skMatch.click(); }
          return false;
        }
        if (elapsed < SK_GIVE_UP_AT) return false;
        // Genuinely failed - fall through to Dawn so the cart form is still right.
      }
    }

    // 2) Dawn's radios. Click the unchecked target so the theme's own change
    // handler fires (updates price, form id, and the pre-order UI).
    var radios = scope.querySelectorAll('input[type="radio"]');
    var match = Array.prototype.filter.call(radios, function (i) { return norm(i.value) === norm(TARGET); })[0];
    if (match) {
      // (a) Don't fire until Dawn's listener can exist. If the theme never
      // defines it (non-Dawn markup), give up waiting after a few seconds.
      var dawnReady = !!(window.customElements && customElements.get('variant-selects'));
      if (!dawnReady && elapsed < WAIT_FOR_DAWN_UNTIL) return false;

      if (!match.checked) { match.click(); return false; }   // verify next tick

      // (b) Radio is on; confirm the theme actually switched. If not, the
      // click's change event was lost - send it again.
      var ok = themeHasTarget(scope, TARGET);
      if (ok === null || ok === true) return true;
      if (resyncs < MAX_RESYNC) {
        resyncs++;
        match.dispatchEvent(new Event('change', { bubbles: true }));
      }
      return false;   // section fetch is async; check again next tick
    }

    // SK-only markup (no Dawn radio to verify against): the pill is the truth.
    if (skSelected) return true;

    // 3) Dropdown fallback
    var selects = scope.querySelectorAll('select');
    for (var s = 0; s < selects.length; s++) {
      var sel = selects[s];
      var opt = Array.prototype.filter.call(sel.options, function (o) { return norm(o.value) === norm(TARGET); })[0];
      if (opt) {
        if (sel.value !== opt.value) {
          sel.value = opt.value;
          sel.dispatchEvent(new Event('change', { bubbles: true }));
        }
        return true;
      }
    }
    return false;
  }

  function run() { try { return preselect(); } catch (e) { return false; } }

  function start() {
    startedAt = Date.now();
    if (run()) return;
    var deadline = startedAt + 8000;
    var timer = setInterval(function () {
      if (run() || Date.now() >= deadline) { clearInterval(timer); }
    }, 250);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();